<template>
  <div class="shadow rounded border">
    <div class="position-relative">
      <canvas ref="canvas" class="rounded-top textureImage" />
    </div>
    <div class="p-2">
      <el-link class="m-2" type="danger" @click="emitDelete">
        {{ $t('general.remove') }}
      </el-link>
      <el-collapse>
        <el-collapse-item name="1">
          <div slot="title" class="font-weight-bold d-flex align-items-center">
            <div
              v-if="value.elasticBackground"
              ref="basecolor"
              class="preview-color-square rounded"
              :style="{ background: value.elasticBackground.hex }"
            />
            <span>{{ groundColorText }}</span>
          </div>
          <div>
            <ColorSquarePicker v-model="value.elasticBackground" :colors="mappedRAL" />
          </div>
        </el-collapse-item>
        <el-collapse-item name="2">
          <div slot="title" class="font-weight-bold d-flex align-items-center">
            <div
              v-for="flake in value.flakes"
              :key="flake.id"
              ref="color"
              class="preview-color-square rounded"
              :style="{ background: flake.color.hex }"
            >
              <span ref="amounts">{{ flake.amount }}%</span>
            </div>
            <span>{{ $t('general.flakes') }}</span>
          </div>
          <div class="text-left">
            <el-button @click="addFlake">
              {{ $t('general.add_flake') }}
            </el-button>
            <el-tabs>
              <el-tab-pane
                v-for="(flake, index) in value.flakes"
                :key="flake.id"
                :label="index + 1 + '. ' + flake.color.name"
              >
                <div class="d-flex justify-content-end">
                  <el-button v-if="flake.id > 1" type="danger" circle @click="onDeleteFlake(flake)">
                    <i class="el-icon-close" />
                  </el-button>
                </div>
                <el-slider
                  v-model="flake.amount"
                  :show-tooltip="false"
                  :step="5"
                  :max="getFreeAmount(flake.id)"
                  class="mx-2"
                ></el-slider>
                <ColorSquarePicker v-model="flake.color" :colors="FLAKECOLORS" />
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import QCVSANDS from '../../js/constants/qcvsands';
import ColorSquarePicker from './ColorSquarePicker';
import FlakesGenerator from '../../js/FlakesGenerator';
import RALCOLORS from '../../js/constants/ral-colors';
import FLAKECOLORS from '@/js/constants/flakeColors';
export default {
  name: 'ElasticTextureCard',
  components: { ColorSquarePicker },
  props: {
    ind: {
      type: Number,
    },
    value: {
      type: Object,
    },
  },
  mounted() {
    this.flakeGenerator = new FlakesGenerator(this.$refs.canvas);
    this.flakeGenerator.drawFlakes(this.value.elasticBackground.hex, this.value.flakes);
  },
  destroyed() {},
  data() {
    return {
      RALCOLORS,
      QCVSANDS,
      FLAKECOLORS,
      flakeGenerator: null,
    };
  },
  computed: {
    groundColorText() {
      if (this.value.elasticBackground) {
        return (
          this.$t('general.groundcolor') +
          ': ' +
          this.value.elasticBackground.name +
          ' (RAL' +
          this.value.elasticBackground.code +
          ')'
        );
      }

      return this.$t('general.groundcolor');
    },
    mappedRAL() {
      return RALCOLORS.map((el) => {
        return {
          ID: el.code,
          code: el.code,
          NAME: el.name,
          RGBCODE: el.rgb,
          HEXCODE: el.hex,
        };
      });
    },
  },
  watch: {
    value: {
      deep: true,
      handler() {
        this.flakeGenerator.drawFlakes(this.value.elasticBackground.hex, this.value.flakes);
        this.$emit('input', this.value);
      },
    },
  },
  methods: {
    emitDelete() {
      this.$emit('delete');
    },
    getFreeAmount(index) {
      if (this.value.flakes.length === 1) return 100;

      let dd = this.value.flakes.filter((el) => el.id !== index);
      let a = 0;
      for (let i = 0; i < dd.length; i++) {
        a += dd[i].amount;
      }
      return 100 - a;
    },
    addFlake() {
      if (this.value.flakes.length < 3) {
        let a = 0;
        for (let i = 0; i < this.value.flakes.length; i++) {
          a += this.value.flakes[i].amount;
        }
        let b = 100 - a;

        this.value.flakes.push({
          id: this.value.flakes.length + 1,
          color: { name: 'HF-54, gelbgrün', hex: '#60aa42' },
          amount: b,
        });
      }
    },
    onDeleteFlake(flake) {
      this.value.flakes.splice(this.value.flakes.indexOf(flake), 1);
    },
  },
};
</script>

<style scoped>
.textureImage {
  height: 25vh;
  width: 100%;
}

.preview-color-square {
  width: 30px;
  height: 30px;
  margin-right: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.preview-color-square span {
  padding: 2px;
  font-size: 10px;
  border-radius: 5px;
  text-align: center;
  color: white;
  text-shadow: 1px 1px 1px black, 1px -1px 1px black, -1px 1px 1px black, -1px -1px 1px black;
}
</style>
